export default __webpack_public_path__ + "static/media/video-heading.png?.36bb0458";